/**
 *
 * Categories
 *
 */
import React, { memo } from 'react';
import { DataTable } from './components/view-list';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
interface Props {}

export const SubCategories = memo((props: Props) => {
  return (
    <div>
      <Link
        to="/blogs/categories"
        className="flex items-center gap-2 mb-4 text-sm text-gray-500"
      >
        <ArrowLeft className="w-4 h-4" />
        Back to Categories
      </Link>
      <DataTable />
    </div>
  );
});
